<svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.5 0.5H19.3333V2.83333H13.8333V8.16667H8.49996V13.5H0.666626V11.1667H6.16663V5.83333H11.5V0.5Z" fill="#212121"/>
</svg>
